import { FaultData } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useFaultDataByDiagnosticId(
  diagnosticId: string,
  deviceId: string,
  fromDate: Date,
  toDate: Date,
) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery<FaultData[]>({
    queryKey: ["faultDataByDiagnosticId", activeSessionId, diagnosticId, deviceId],

    queryFn: async ({ signal }) => {
      if (!deviceId || !diagnosticId) {
        return Promise.resolve([]);
      }

      const res = geotabClient.get(
        "FaultData",
        {
          deviceSearch: {
            id: deviceId,
          },
          diagnosticSearch: {
            id: diagnosticId,
          },
          fromDate: fromDate,
          toDate: toDate,
        },
        5000,
        signal,
      );
      return res;
    },
  });
}
